module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["cellBox"]
  }, [_c('dof-cell', {
    key: 'cellIsColmo' + _vm._isColmo,
    attrs: {
      "title": _vm.title,
      "hasArrow": false,
      "hasTopBorder": false,
      "hasSubTopBorder": false,
      "hasBottomBorder": false,
      "hasSubBottomBorder": false,
      "backgroundColor": _vm.backgroundColor,
      "disabled": _vm.disabled
    },
    on: {
      "dofCellClicked": _vm.dofCellClick
    }
  }, [(_vm.radioIcon && _vm._isColmo) ? _c('dof-iconfont', {
    attrs: {
      "slot": "switch",
      "code": '\u4729',
      "size": 50,
      "color": 'rgba(255, 255, 255, 0.8)'
    },
    slot: "switch"
  }) : _vm._e(), (_vm.radioIcon && !_vm._isColmo) ? _c('image', {
    staticClass: ["radio"],
    attrs: {
      "slot": "switch",
      "src": _vm.radioIcon
    },
    slot: "switch"
  }) : _vm._e()], 1), (!_vm.isLast && _vm.isShowBorder) ? _c('div', {
    staticClass: ["fakeStyle"],
    style: {
      backgroundColor: _vm._isColmo ? 'rgba(255, 255, 255, 0.14)' : '#dddddd',
      right: _vm.isFullBorder ? '0px' : '24px'
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-f6a28b84!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-radio-list/radio-item.vue
// module id = 677
// module chunks = 0 1